import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import { Route, Switch } from "react-router";
import styled, { css } from "styled-components";
import { observer, Provider } from "mobx-react";

import "app/config/general";
import { RoutePaths } from "app/config/routePaths";
import { DevTools } from "app/components/devTools/DevTools";
import { mockStore } from "app/stores/mockStore/mockStore";
import { ErrorBoundary } from "app/components/ErrorBoundary";
import { RootComponents } from "app/RootComponents";
import { WallBoard } from "app/components/wallBoard/WallBoard";
import { MainStore } from "app/stores/mainStore";

const AppView = styled.div``;
const Content = styled.div`
  ${(props: {}) => css`
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 100vh;
    width: 100%;
  `};
`;
const MainContainer = styled.div`
  ${(props: {}) => css`
    display: flex;
    height: 100vh;
  `};
`;
@observer
export class App extends React.Component {
  readonly mainStore: MainStore = new MainStore();
  render() {
    return (
      <Provider mockStore={mockStore}>
        <AppView>
          <ErrorBoundary>
            <RootComponents />
            <BrowserRouter>
              <MainContainer>
                <Content>
                  <Switch>
                    <Route path={RoutePaths.ROOT} exact={true} component={() => <WallBoard store={this.mainStore} />} />
                  </Switch>
                </Content>
              </MainContainer>
            </BrowserRouter>
            <DevTools />
          </ErrorBoundary>
        </AppView>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./app/App.tsx